import { render, staticRenderFns } from "./ReservePage.vue?vue&type=template&id=20fbab4a&scoped=true&lang=pug"
import script from "./ReservePage.vue?vue&type=script&lang=js"
export * from "./ReservePage.vue?vue&type=script&lang=js"
import style0 from "./ReservePage.vue?vue&type=style&index=0&id=20fbab4a&prod&lang=scss&scoped=true"
import style1 from "./ReservePage.vue?vue&type=style&index=1&id=20fbab4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4_d129e92f74051bdaf507e89873890984/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbab4a",
  null
  
)

export default component.exports